import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=0e3b279e&scoped=true"
import script from "./ButtonSecondary.vue?vue&type=script&lang=js"
export * from "./ButtonSecondary.vue?vue&type=script&lang=js"
import style0 from "./ButtonSecondary.vue?vue&type=style&index=0&id=0e3b279e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b279e",
  null
  
)

export default component.exports